/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import tinymce from 'tinymce';
import I18n from 'I18n';
import { mapObject } from 'rich-text-lib/utils/iterables';
import { __HS_I18N } from '../constants/plugins';
import { DUMMY_LANG_URL } from '../constants/hsi18n';
import { lang } from './lang';
tinymce.ScriptLoader.markDone(DUMMY_LANG_URL);
const i18nPrefix = 'TinymceUI';
function i18nPlugin(editor) {
  const {
    directionality = 'ltr',
    language = 'en'
  } = editor.settings;

  // Left side (key) matches tinymce source (must have full string exactly)
  // Right side (val) is translation key

  const addI18n = () => {
    const langWithI18n = mapObject(val => I18n.text(`${i18nPrefix}.${val}`), lang);
    tinymce.addI18n(language, Object.assign({
      _dir: directionality
    }, langWithI18n));
  };
  const isLegacyI18n = !!I18n.Info;
  if (isLegacyI18n) {
    I18n.Info.then(addI18n);
  } else {
    addI18n();
  }
}
export const HS_I18N = __HS_I18N;
tinymce.PluginManager.add(HS_I18N, i18nPlugin);